import React, { Component } from 'react';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup, Switch } from '@material-ui/core';

export class SingleRadio extends Component {
    state = {  }
    render() {
        return (
            <FormControlLabel control={<Radio />} {...this.props} />
        );
    }
}

export class GroupRadio extends Component {
    state = {  }
    render() {
        const { value, label, arialabel, name, onChange, color, children, required  } = this.props;
        return (
            <Box p={1}>
                <FormControl component="fieldset" required={required}>
                    <FormLabel >{label}</FormLabel>
                    <RadioGroup
                        aria-label={arialabel}
                        style={{ flexDirection: 'row' }}
                        name={name}
                        value={value}
                        onChange={onChange}
                        color={color}
                    >
                        {children}
                    </RadioGroup>
                </FormControl>
            </Box>
        );
    }
}

export class SingleSwitch extends Component {
    state = {  }
    render() {
        return (
            <FormControlLabel control={<Switch />} {...this.props} />
        );
    }
}

export class GroupSwitch extends Component {
    state = {  }
    render() {
        const { value, label, arialabel, groupName, onChange, children, required  } = this.props;
        return (
            <Box p={1}>
                <FormControl component="fieldset" required={required}>
                    <FormLabel >{label}</FormLabel>
                    <FormGroup
                        aria-label={arialabel}
                        style={{ flexDirection: 'column' }}
                        name={groupName}
                        value={value}
                        onChange={onChange}
                    >
                        {children}
                    </FormGroup>
                </FormControl>
            </Box>
        );
    }
}
export class SingleCheckbox extends Component {
    state = {  }
    render() {
        const { value, label, onChange, checked, color, name } = this.props;
        return (
            <FormControlLabel 
                label={label}
                control={
                    <Checkbox 
                        style={{ color: color}}
                        checked={checked} 
                        value={value} 
                        name={name} 
                        onChange={onChange} 
                        color="primary"
                    />
                }
            />
        );
    }
}

export class GroupCheckbox extends Component {
    state = {  }
    render() {
        const { label, children, required, name, direction  } = this.props;
        let dir = direction ? direction : 'row'
        return (
            <Box p={1}>
                <FormControl component="fieldset"  required={required} name={name}>
                    <FormLabel >{label}</FormLabel>
                    <Box style={{ display: 'flex', flexDirection: dir, ml: 3 }}>
                        {children}
                    </Box>
                </FormControl>
            </Box>
        );
    }
}

                // <Box>
                //     <Checkbox  defaultChecked />
                //     <Checkbox  defaultChecked color="secondary" title={"Projet"} />
                //     <Checkbox  defaultChecked color="success" />
                //     <Checkbox  defaultChecked color="default" />
                //     <Checkbox defaultChecked
                //         sx={{
                //         color: pink[800],
                //         '&.Mui-checked': {
                //             color: pink[600],
                //         },
                //         }}
                //     />
                // </Box>